// Importación de librerías y componentes necesarios
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Drawer, Modal, Card, Button, Tooltip, Pagination, Row, Col, message, Checkbox, Input, Dropdown, Menu, Typography, Select, Divider, Radio, Space, Tabs, Spin, Progress } from "antd";
import { FilePdfOutlined, FileWordOutlined, FileExcelOutlined, FileImageOutlined, FileZipOutlined, FileMarkdownOutlined, FilePptOutlined, FileUnknownOutlined, SettingOutlined, OrderedListOutlined, UnorderedListOutlined, ClockCircleOutlined, SearchOutlined, EllipsisOutlined, StarOutlined, LeftOutlined, GlobalOutlined, EditOutlined, MoreOutlined, FileOutlined, FolderOpenOutlined, FolderOutlined, HistoryOutlined, StarFilled, HeartOutlined, HolderOutlined, AppstoreOutlined, FilterOutlined, FileTextOutlined, CloseOutlined, RightOutlined, DownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import RepositorioService from "../../../services/inicio/repositorio/repositorioDocumentoService.js";
import RepositorioPOAProyecto from "../../../services/inicio/repositorio/repositorioPOAService.js";
import RenombrarCarpeta from "./GestorRespositorio/RenombrarCarpeta.jsx";
import { downloadFile, getViewFileUrl, deleteFolder, deleteFile, downloadZip, downloadFolderZip, formatBytes } from '../../../services/inicio/repositorio/repositorioDescargarVerService.js';
import CrearCarpeta from "./GestorRespositorio/CreateFolder.jsx";
import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../../store/auth/selectors.js";
import ListaRepositorio from "./GestorRespositorio/ListaRepositorio.jsx"
import PedagogicalPlanModal from './PlanPedagogicoInicial/PedagogicalPlanModal.jsx';

// Importación de estilos personalizados
import "./FileExplorer.css";

// Componentes de Ant Design utilizados
const { Search } = Input;
const { Option } = Select;
const { Text, Title } = Typography;


// Mapeo de modos a estados
const MODE_TO_ESTADO = {
  planesPedagogicos: 1,
  nuevosParticipantes: 2,
  contrapartida: 3,
  full: undefined,
};

const normalizeRepoPath = (path = "") => {
  return path
    .replace(/\\/g, "/")
    .replace(/^.*DocumentosFAO\//, "DocumentosFAO/")
    .replace(/\/+$/, "");
};

// Configuración de modos del repositorio
const REPOSITORY_MODES = {
  full: {
    title: "Repositorio documental",
    rootFolderName: null,
    headerColor: "#02172F", // Azul noche (principal)
  },
  nuevosParticipantes: {
    title: "Nuevos Participantes",
    rootFolderName: "Nuevos Participantes",
    headerColor: "#0B3D2E", // Verde bosque profundo
  },
  contrapartida: {
    title: "Contrapartida",
    rootFolderName: "Contrapartida",
    headerColor: "#3A1F04", // Marrón cobre oscuro
  },
  planesPedagogicos: {
    title: "Planes Pedagógicos",
    rootFolderName: "planesPedagogicos",
    headerColor: "#2B145A", // Morado institucional
  },
};

// Componente principal del repositorio de documentos
const RepositorioDocumento = ({ open, onCloseMetodo, proyectoCodigo, mode }) => {
  // Estados del componente
  const [dataInicial, setDataInicial] = useState(null);

  const [itemsPerPage, setItemsPerPage] = useState(5); // Elementos por página
  const [searchQuery, setSearchQuery] = useState(""); // Búsqueda
  const [sortBy, setSortBy] = useState("name"); // Ordenar por
  const [sortOrder, setSortOrder] = useState("asc"); // Orden ascendente o descendente
  const [viewMode, setViewMode] = useState("list"); // Modo de vista
  const [currentPage, setCurrentPage] = useState(1); // Página actual
  const [filterType, setFilterType] = useState("all"); // Tipo de filtro
  const [activeTab, setActiveTab] = useState("all"); // Pestaña activa
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const [favorites, setFavorites] = useState([]); // Elementos favoritos
  const [selectedItems, setSelectedItems] = useState([]); // Elementos seleccionados
  const totalItems = dataInicial?.children?.length ?? 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [breadcrumbPath, setBreadcrumbPath] = useState([]);
  const [modalVisiblePalnPedagogico, setModalVisiblePalnPedagogico] = useState(false);
  const [selectedFilePalnPedagogico, setSelectedFilePalnPedagogico] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [rootFileCount, setRootFileCount] = useState(0);
  const [totalFolderCount, setTotalFolderCount] = useState(0);
  const [selectedPath, setSelectedPath] = useState("");
  const [filteredFolders, setFilteredFolders] = useState([]);
  const [filteredDataFiles, setFilteredDataFiles] = useState([]);
  const [menuVisible, setMenuVisible] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterFile, setFilterFile] = useState(''); // Estado para el filtro de archivos
  const [loading, setLoading] = useState(false);
  const [menuTree, setMenuTree] = useState([]);

  // ── Progreso de descarga ──────────────────────────────────────────────────
  const [dlProgress, setDlProgress] = useState(null); // null = inactivo
  // { label: string, percent: number (-1 = indeterminado), loaded: number, total: number }
  // Estados para el modal de eliminación de carpetas
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [folderToDelete, setFolderToDelete] = useState(null);
  // Estados para el modal de eliminación de archivos
  const [fileToDelete, setFileToDelete] = useState(null);
  const [deleteFileModalVisible, setDeleteFileModalVisible] = useState(false);
  const [mostrarLista, setMostrarLista] = useState(true);
  const [selectedKey, setSelectedKey] = useState(null);
  const [openKeys, setOpenKeys] = useState([]); // Estado para manejar submenús abiertos
  const [renameModalVisible, setRenameModalVisible] = useState(false);
  const [folderToRename, setFolderToRename] = useState(null);
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const appName = 'repositorio_documental';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const permissionInsert = permissions.priv_insert === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionExport = permissions.priv_export === 'Y';
  const permissionView = permissions.priv_print === 'Y';
  const permissionPrint = permissions.priv_print === 'Y';




  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        let data = [];
        const estado = MODE_TO_ESTADO[mode];
        if (proyectoCodigo) {
          const codigoLimpio = proyectoCodigo.replace(/^P0?|P\d+/, "");
          data = await RepositorioPOAProyecto.getDato(codigoLimpio, estado);
        } else {
          data = await RepositorioService.getDocuments(userLogin);
        }
        updateStats(data);
        setDataInicial(data);
        setMenuTree(data);
        if (Array.isArray(data) && data.length > 0) {
          initLevelOne(data[0]);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchDocuments();
  }, [proyectoCodigo, userLogin, mode]);


  const initLevelOne = (rootNode) => {
    if (!rootNode) return;

    // 📌 Breadcrumb inicial
    const breadcrumb = [{ id: rootNode.id, name: rootNode.name }];
    setBreadcrumbPath(breadcrumb);

    // 📌 Carpeta seleccionada
    setSelectedKey(rootNode.id);
    setSelectedFolder(rootNode.name);
    setSelectedPath(normalizeRepoPath(rootNode.path));

    // 📌 Menú abierto
    setOpenKeys([String(rootNode.id)]);

    // 📌 Mostrar contenido interno
    const arrayData = rootNode.children || [];

    setFilterFile(arrayData);
    setFilteredFolders(filtrarCarpetas(arrayData, 1));
    setFilteredDataFiles(filtrarCarpetas(arrayData, 2));

    setRootFileCount(arrayData.filter(i => i.type === "file").length);
    setTotalFolderCount(arrayData.filter(i => i.type === "folder").length);
  };

  const convertToBytes = (sizeStr) => {
    if (!sizeStr) return 0;
    const units = { B: 1, KB: 1024, MB: 1024 ** 2, GB: 1024 ** 3 };
    const match = sizeStr.match(/^([\d.]+)\s*(B|KB|MB|GB)$/i);
    if (!match) return 0; // Si no coincide con el formato esperado, devolver 0
    const [_, value, unit] = match;
    return parseFloat(value) * (units[unit.toUpperCase()] || 1);
  };

  const formatSize = (bytes) => {
    if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
    if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(2)} MB`;
    if (bytes >= 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${bytes} B`;
  };

  // Función para actualizar las estadísticas del repositorio
  const updateStats = useCallback((data) => {
    let fileCount = 0;
    let folderCount = 0;
    let totalSizeBytes = 0;

    const countItems = (items) => {
      if (!Array.isArray(items)) return;

      items.forEach((item) => {
        if (item.type === "file") {
          fileCount++;
          // Validamos el tipo de size
          if (typeof item.size === "string") {
            totalSizeBytes += convertToBytes(item.size);
          } else if (typeof item.size === "number") {
            totalSizeBytes += item.size;
          }
        } else if (item.type === "folder") {
          folderCount++;
          if (item.children) {
            countItems(item.children);
          }
        }
      });
    };
    countItems(data);
    setStats((prevStats) => {
      const formattedSize = formatSize(totalSizeBytes);
      if (
        prevStats.totalFiles === fileCount &&
        prevStats.totalFolders === folderCount &&
        prevStats.totalSize === formattedSize
      ) {
        return prevStats;
      }
      return {
        ...prevStats,
        totalFiles: fileCount,
        totalFolders: folderCount,
        totalSize: formattedSize,
      };
    });
  }, []);

  useEffect(() => {
    if (dataInicial && Array.isArray(dataInicial)) {
      updateStats(dataInicial);
    }
  }, [dataInicial, updateStats]);

  // Estado para las estadísticas
  const [stats, setStats] = useState({
    totalFiles: 0,
    totalFolders: 0,
    totalSize: "0 MB",
  });

  const onClose = () => {
    onCloseMetodo();
    setBreadcrumbPath([]);
    setSelectedFolder("Repositorio Documental");
    setActiveTab("all");
    setOpenKeys([]);
    setSelectedItems([]);
    setSelectedPath("");
  };

  // Configuración del menú de filtros
  const filterMenu = {
    items: [
      {
        key: "file-type",
        label: (
          <div className="menu-section-repositorio" style={{ padding: "12px" }} onClick={(e) => e.stopPropagation()}>
            <Typography.Text strong className="menu-title-repositorio">Tipo de archivo</Typography.Text>
            <Select
              value={filterType}
              onChange={(value) => setFilterType(value)}
              className="select-repositorio"
              style={{ width: "100%", marginTop: "5px" }}
            >
              <Option value="all">Todos los tipos</Option>
              <Option value="pdf">PDF</Option>
              <Option value="docx">Word (DOCX)</Option>
              <Option value="xlsx">Excel (XLSX)</Option>
              <Option value="jpg">Imagen (JPG)</Option>
              <Option value="png">Imagen (PNG)</Option>
              <Option value="url">Enlaces URL</Option>
            </Select>
          </div>
        ),
      },
      { key: "divider-1", type: "divider" },
      {
        key: "sort-by",
        label: (
          <div className="menu-section-repositorio" style={{ padding: "5px" }} onClick={(e) => e.stopPropagation()}>
            <Typography.Text strong className="menu-title-repositorio">Ordenar por</Typography.Text>
            <Radio.Group
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="radio-group-repositorio"
            >
              <Radio className="radio-option-repositorio" value="name">Nombre</Radio>
              <Radio className="radio-option-repositorio" value="date">Fecha</Radio>
              <Radio className="radio-option-repositorio" value="size">Tamaño</Radio>
            </Radio.Group>
          </div>
        ),
      },
      { key: "divider-2", type: "divider" },
      {
        key: "order",
        label: (
          <div className="menu-section-repositorio" style={{ padding: "12px" }} onClick={(e) => e.stopPropagation()}>
            <Typography.Text strong className="menu-title-repositorio">Orden</Typography.Text>
            <Radio.Group
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="radio-group-repositorio"
            >
              <Space direction="vertical" size="small">
                <Radio className="radio-option-repositorio" value="asc">Ascendente (A-Z)</Radio>
                <Radio className="radio-option-repositorio" value="desc">Descendente (Z-A)</Radio>
              </Space>
            </Radio.Group>
          </div>
        ),
      },
    ],
  };

  // Función para filtrar carpetas
  const filtrarCarpetas = (data, option) => {
    if (!Array.isArray(data)) return [];
    return data.filter((item) =>
      option === 1 ? item.type === "folder" : item.type !== "folder"
    );
  };

  // Configuración del menú de vista
  const items = [
    {
      key: "list",
      label: (
        <div onClick={() => setViewMode("list")}>
          <UnorderedListOutlined /> Lista
        </div>
      ),
    },
    {
      key: "grid",
      label: (
        <div onClick={() => setViewMode("grid")}>
          <HolderOutlined /> Cuadrícula
        </div>
      ),
    },
    {
      key: "compact",
      label: (
        <div onClick={() => setViewMode("compact")}>
          <FileTextOutlined style={{ fontSize: "12px" }} /> Compacta
        </div>
      ),
    },
    { key: "divider", type: "divider" },
    {
      key: "items-per-page",
      label: (
        <div>
          Items por página
          <Select
            value={itemsPerPage}
            style={{ width: 70, marginLeft: "8px" }}
            size="small"
            onChange={setItemsPerPage}
            onClick={(e) => e.stopPropagation()}
          >
            <Select.Option value={10}>10</Select.Option>
            <Select.Option value={20}>20</Select.Option>
            <Select.Option value={50}>50</Select.Option>
            <Select.Option value={100}>100</Select.Option>
          </Select>
        </div>
      ),
    },
  ];

  // Función para obtener el ícono según la extensión del archivo
  const getFileIconByExtension = (extWithDot) => {
    const ext = extWithDot?.replace('.', '').toLowerCase();

    switch (ext) {
      case 'pdf':
        return <FilePdfOutlined className="me-3 fs-5" style={{ color: '#d32f2f' }} />;
      case 'doc':
      case 'docx':
        return <FileWordOutlined className="me-3 fs-5" style={{ color: '#1976d2' }} />;
      case 'xls':
      case 'xlsx':
        return <FileExcelOutlined className="me-3 fs-5" style={{ color: '#388e3c' }} />;
      case 'ppt':
      case 'pptx':
        return <FilePptOutlined className="me-3 fs-5" style={{ color: '#e64a19' }} />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <FileImageOutlined className="me-3 fs-5" style={{ color: '#6a1b9a' }} />;
      case 'zip':
      case 'rar':
        return <FileZipOutlined className="me-3 fs-5" style={{ color: '#ff8f00' }} />;
      case 'txt':
        return <FileTextOutlined className="me-3 fs-5" style={{ color: '#455a64' }} />;
      case 'md':
        return <FileMarkdownOutlined className="me-3 fs-5" style={{ color: '#607d8b' }} />;
      default:
        return <FileUnknownOutlined />;
    }
  };

  // Función para aplanar archivos en una estructura
  const flattenFiles = (folder) => {
    if (!folder || !Array.isArray(folder.children)) {
      return [];
    }
    let files = [];
    folder.children.forEach((item) => {
      if (item.type === "file" || item.type === "link") {
        files.push(item);
      } else if (item.type === "folder") {
        files = files.concat(flattenFiles(item));
      }
    });
    return files;
  };

  // Archivos aplanados y paginados
  const allFiles = flattenFiles(dataInicial);

  // Filtrar archivos según el tipo seleccionado
  const filteredFiles = allFiles.filter((file) => {
    if (filterType === "all") return true;
    if (filterType === "pdf" && file.name.endsWith(".pdf")) return true;
    if (filterType === "docx" && file.name.endsWith(".docx")) return true;
    if (filterType === "xlsx" && file.name.endsWith(".xlsx")) return true;
    if (filterType === "jpg" && file.name.endsWith(".jpg")) return true;
    if (filterType === "png" && file.name.endsWith(".png")) return true;
    if (filterType === "url" && file.type === "link") return true;
    return false;
  });

  // Extensiones que se pueden abrir en el navegador
  const openableExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];

  // Función para alternar selección de elementos
  const toggleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Función para alternar favoritos
  const toggleFavorite = (id) => {
    setFavorites((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Menú de opciones para carpetas
  const folderMenu = (folder) => [
    { key: "openFolder", label: "Abrir", icon: <FolderOpenOutlined style={{ color: "#1f6ddb" }} /> },
    // Si tienes permiso de actualización, agrega el item de renombrar
    ...(permissionUpdate
      ? [
        {
          key: "renameFolder",
          label: "Renombrar",
          icon: <EditOutlined />,
          onClick: ({ domEvent }) => {
            domEvent.stopPropagation();
            showRenameModal(folder);
          },
        },
        {
          key: "downloadFolder",
          label: "Descargar carpeta",
          icon: <DownloadOutlined />,
          onClick: ({ domEvent }) => {
            domEvent.stopPropagation();
            handleDownloadFolder(folder);
          },
        }
      ]
      : []),

    // Si tienes permiso de eliminación, agregamos el item de eliminar
    ...(permissionDelete && selectedKey !== null
      ? [
        {
          key: "deleteFolder",
          label: "Eliminar",
          icon: <DeleteOutlined style={{ color: "red" }} />,
          onClick: ({ domEvent }) => {
            domEvent.stopPropagation();
            showDeleteConfirmation(folder);
          },
        },
      ]
      : []),

  ];

  // ── Helper: disparar descarga de un Blob ─────────────────────────────────
  const triggerBlobDownload = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // Función para descargar la carpeta actualmente abierta (raíz de la vista)
  const handleDownloadCurrentFolder = () => {
    const currentNode = findNodeById(selectedKey, dataInicial);
    if (!currentNode) {
      message.error("No se pudo determinar la carpeta actual");
      return;
    }
    handleDownloadFolder(currentNode);
  };

  // Función para descargar una carpeta como ZIP
  const handleDownloadFolder = async (folder) => {
    if (!folder || !folder.path) {
      message.error("No se encontró la ruta de la carpeta");
      return;
    }
    const relativePath = folder.path.replace("/var/www/html/backend/", "");
    setLoading(true);
    setDlProgress({ label: `Descargando "${folder.name}.zip"…`, percent: -1, loaded: 0, total: 0 });

    try {
      const response = await downloadFolderZip(relativePath, (percent, loaded, total) => {
        setDlProgress({
          label: `Descargando "${folder.name}.zip"…`,
          percent,
          loaded,
          total,
        });
      });

      triggerBlobDownload(
        new Blob([response.data], { type: 'application/zip' }),
        `${folder.name}.zip`
      );
      message.success("Descarga completa");
    } catch (err) {
      console.error("Error al descargar carpeta:", err);
      message.error("Error al descargar la carpeta");
    } finally {
      setLoading(false);
      setDlProgress(null);
    }
  };

  // Función para descargar un archivo individual
  const handleDownload = async (file) => {
    const safeFileName = file.name?.includes('.') ? file.name : `${file.name}.${file.extension}`;
    setDlProgress({ label: `Descargando "${safeFileName}"…`, percent: -1, loaded: 0, total: 0 });

    try {
      const { data } = await downloadFile(file.id, (percent, loaded, total) => {
        setDlProgress({ label: `Descargando "${safeFileName}"…`, percent, loaded, total });
      });

      triggerBlobDownload(new Blob([data]), safeFileName);
    } catch (error) {
      console.error('Error al descargar:', error);
      message.error('Error al descargar el archivo');
    } finally {
      setDlProgress(null);
    }
  };

  // Función para abrir un archivo
  const handleOpen = (file) => {
    const ext = file.extension?.toLowerCase();
    if (openableExtensions.includes(ext)) {
      const fileUrl = getViewFileUrl(file.id); // asumes que sirve para abrir en nueva pestaña
      window.open(fileUrl, "_blank");
    } else {
      message.warning("Este tipo de archivo no se puede previsualizar. Se descargará.");
      handleDownload(file);
    }
  };

  // Menú de opciones para archivos
  const fileMenu = (file) => {
    const items = [];
    if (permissionView) {
      items.push({
        key: "1",
        icon: <FileOutlined className="menu-icon" />,
        label: "Abrir",
        onClick: () => handleOpen(file),
      });
    }

    if (permissionExport) {
      items.push({
        key: "2",
        icon: <DownloadOutlined className="menu-icon" />,
        label: "Descargar",
        onClick: () => handleDownload(file),
      });
    }

    if (permissionDelete) {
      items.push({
        key: "3",
        icon: <DeleteOutlined className="menu-icon text-danger" />,
        label: "Eliminar archivo",
        onClick: () => showDeleteFileConfirmation(file),
      });
    }

    return items;
  };

  // Función para construir la ruta de migas de pan
  function buildBreadcrumbFor(folderItem, root) {
    console.group("🔗 buildBreadcrumbFor");
    let breadcrumb = [];
    let current = folderItem;
    while (current) {
      breadcrumb.unshift({ id: current.id, name: current.name });
      if (current.parentKey == null) {
        break;
      }
      current = findNodeById(current.parentKey, root);
      if (!current) {
        console.warn("⚠️ parentKey no encontrado en el árbol");
      }
    }
    return breadcrumb;
  }

  // Función para encontrar un nodo por su ID
  function findNodeById(nodeId, data) {
    const numericId = Number(nodeId);
    if (!data) return null;
    // 🟢 Si es un array, buscar en cada nodo raíz
    if (Array.isArray(data)) {
      for (const node of data) {
        const found = findNodeById(numericId, node);
        if (found) return found;
      }
      return null;
    }
    // 🟢 Si es un nodo normal
    if (data.id === numericId) {
      return data;
    }
    if (data.children?.length) {
      for (const child of data.children) {
        const found = findNodeById(numericId, child);
        if (found) return found;
      }
    }
    return null;
  }

  // Función para manejar clics en el menú
  const handleClick = useCallback((folderItem) => {
    setSelectedItems([]);
    let newBreadcrumb = [];
    let arrayData = [];
    // 🔎 Buscar siempre el nodo REAL en el árbol
    const realNode = findNodeById(folderItem.id, dataInicial);
    if (!realNode) {
      console.error("❌ Nodo real no encontrado", folderItem);
      return;
    }
    setSelectedPath(normalizeRepoPath(realNode.path));
    // 🍞 Construir breadcrumb REAL (sin root falso)
    newBreadcrumb = buildBreadcrumbFor(realNode, dataInicial);

    // 📂 Datos a mostrar
    arrayData = realNode.children || [];

    // 🎯 Estados principales
    setSelectedFolder(realNode.name);
    setSelectedKey(realNode.id);

    // 🔑 CLAVE: abrir el menú según la ruta completa
    setOpenKeys(newBreadcrumb.map(b => String(b.id)));

    // 📁 Filtrar contenido
    const carpetasFiltradas = filtrarCarpetas(arrayData, 1);
    const archivosFiltrados = filtrarCarpetas(arrayData, 2);

    setFilterFile(arrayData);
    setFilteredFolders(carpetasFiltradas);
    setFilteredDataFiles(archivosFiltrados);

    setRootFileCount(arrayData.filter(i => i.type === "file").length);
    setTotalFolderCount(arrayData.filter(i => i.type === "folder").length);

    // 🍞 Guardar breadcrumb
    setBreadcrumbPath(newBreadcrumb);

  }, [dataInicial, filtrarCarpetas]);

  // Función para formatear el texto
  const formatName = (name) => {
    // Excepciones específicas
    const excepciones = {
      repositorio: "Repositorio Documental",

    };

    if (excepciones[name]) {
      return excepciones[name];
    }

    return name; // Capitaliza
  };

  // Función para navegar a una carpeta Migajas De Pan
  const navigateToFolder = (partialBreadcrumb, event) => {
    event.stopPropagation();
    // El último objeto del array es la carpeta a la que realmente vamos
    const lastObj = partialBreadcrumb[partialBreadcrumb.length - 1];
    // Buscar en tu árbol de dataInicial
    // (asumiendo que usas findNodeById)
    const selectedData = findNodeById(lastObj.id, dataInicial);
    if (!selectedData) {
      // Si no se encuentra, probablemente es la raíz o algo nulo
      console.warn("Carpeta no encontrada");
      return;
    }
    // Ajustar "selected" folder y Key
    setSelectedKey(selectedData.id);
    setSelectedFolder(selectedData.name);
    // Filtrar subcarpetas e hijos
    const arrayData = selectedData.children || [];
    const carpetasFiltradas = filtrarCarpetas(arrayData, 1);
    const archivosFiltrados = filtrarCarpetas(arrayData, 2);
    setFilterFile(arrayData)
    setFilteredDataFiles(archivosFiltrados);
    setFilteredFolders(carpetasFiltradas);
    setSelectedPath(normalizeRepoPath(selectedData.path));
    // Contar archivos y carpetas
    setRootFileCount(arrayData.filter((i) => i.type === "file").length);
    setTotalFolderCount(arrayData.filter((i) => i.type === "folder").length);
    // Actualizar el breadcrumb actual con EXACTAMENTE esa porción
    setBreadcrumbPath(partialBreadcrumb);
  };

  // Texto de la ruta actual en formato string
  const currentPathString = useMemo(() => {
    return breadcrumbPath.map(f => formatName(f.name)).join(" > ");
  }, [breadcrumbPath]);

  // Ruta para eliminación (asegura que la carpeta a eliminar esté al final)
  const pathForDeletion = useMemo(() => {
    if (!folderToDelete) return breadcrumbPath;
    const lastCrumb = breadcrumbPath[breadcrumbPath.length - 1];
    // Si el último elemento no coincide con la carpeta a eliminar, la agregamos
    if (!lastCrumb || lastCrumb.id !== folderToDelete.id) {
      return [...breadcrumbPath, { id: folderToDelete.id, name: folderToDelete.name }];
    }
    return breadcrumbPath;
  }, [breadcrumbPath, folderToDelete]);

  // Función recursiva para actualizar el árbol
  const updateTree = (nodes, action) => {
    if (!Array.isArray(nodes)) return nodes;

    return nodes
      // ❌ ELIMINAR
      .filter(node => {
        if (action.type === "REMOVE") {
          return !action.ids.has(String(node.id));
        }
        return true;
      })
      // 🔁 TRANSFORMAR
      .map(node => {

        // ➕ INSERTAR
        if (
          action.type === "INSERT" &&
          String(node.id) === String(action.parentId)
        ) {
          return {
            ...node,
            children: [...(node.children || []), action.node]
          };
        }
        // 🔄 MERGE
        if (
          action.type === "MERGE" &&
          String(node.id) === String(action.parentId)
        ) {
          return {
            ...node,
            children: mergeChildren(
              node.children || [],
              action.children || []
            )
          };
        }

        // ✏️ RENAME (AQUÍ ESTÁ LA CLAVE)
        if (
          action.type === "RENAME" &&
          String(node.id) === String(action.id)
        ) {
          return {
            ...node,
            name: action.newName,
            path: action.newPath,
            children: node.children
              ? node.children.map(child => ({
                ...child,
                path: child.path.startsWith(action.oldPath)
                  ? child.path.replace(action.oldPath, action.newPath)
                  : child.path
              }))
              : []
          };
        }

        // 🔁 RECURSIVO
        return {
          ...node,
          children: node.children
            ? updateTree(node.children, action)
            : []
        };
      });
  };

  const handleNewFolder = (newFolder) => {
    const normalizedFolder = {
      ...newFolder,
      type: "folder",
      children: [],
      fileCount: 0,
      isLeaf: false,
      path: newFolder.path?.replace(/\/$/, ""), // 🔥 clave
    };

    const action = {
      type: "INSERT",
      parentId: normalizedFolder.parentKey,
      node: normalizedFolder
    };

    setDataInicial(prev => updateTree(prev, action));
    setMenuTree(prev => updateTree(prev, action));

    if (String(normalizedFolder.parentKey) === String(selectedKey)) {
      setFilteredFolders(prev => [...prev, normalizedFolder]);
      setTotalFolderCount(prev => prev + 1);
    }
  };



  const mergeChildren = (oldChildren = [], newChildren = []) => {
    const map = new Map();

    // meter los viejos
    oldChildren.forEach(child => {
      map.set(String(child.id), child);
    });

    // fusionar nuevos
    newChildren.forEach(child => {
      const id = String(child.id);

      if (map.has(id)) {
        // si existe, fusiona recursivamente
        map.set(id, {
          ...map.get(id),
          ...child,
          children: mergeChildren(
            map.get(id).children,
            child.children
          )
        });
      } else {
        // si no existe, agregar
        map.set(id, child);
      }
    });

    return Array.from(map.values());
  };


  // Función para manejar la subida de carpetas
  const handleUploadFolder = (estructura) => {
    if (!estructura || estructura.length === 0) return;
    const updatedParent = Array.isArray(estructura)
      ? estructura[0]
      : estructura;
    const updateTree = (node) => {
      if (String(node.id) === String(updatedParent.id)) {
        return {
          ...node,
          children: mergeChildren(node.children || [], updatedParent.children || [])
        };
      }
      return {
        ...node,
        children: node.children?.map(updateTree) || []
      };
    };
    setDataInicial(prev => {
      const updated = prev.map(updateTree);
      return updated;
    });
    setMenuTree(prev => prev.map(updateTree));
    // 🔄 refrescar vista si estamos en ese folder
    if (String(updatedParent.id) === String(selectedKey)) {
      const mergedChildren = mergeChildren(
        filteredFolders.concat(filteredDataFiles),
        updatedParent.children || []
      );

      setFilteredFolders(mergedChildren.filter(n => n.type === "folder"));
      setFilteredDataFiles(mergedChildren.filter(n => n.type === "file"));
    }
  };


  // Función para manejar el renombrado de carpetas
  const handleFolderRenamed = (updatedFolder, oldPath) => {

    // 🔥 NORMALIZADOR GLOBAL DE RUTAS
    const normalizePath = (p) =>
      p
        ?.replace(/\\/g, "/")   // cambia \ por /
        .replace(/\/+$/, "")    // quita slash final
        .trim();

    const cleanOldPath = normalizePath(oldPath);
    const cleanNewPath = normalizePath(updatedFolder.path);
    const renameRecursively = (node) => {

      const normalizedNodePath = normalizePath(node.path);

      // 🎯 Nodo principal
      if (String(node.id) === String(updatedFolder.id)) {
        return {
          ...node,
          name: updatedFolder.name,
          path: cleanNewPath,
          children: (node.children || []).map(renameRecursively)
        };
      }

      // 🔁 Hijos afectados
      if (normalizedNodePath && normalizedNodePath.startsWith(cleanOldPath)) {
        const newChildPath = normalizedNodePath.replace(cleanOldPath, cleanNewPath);
        return {
          ...node,
          path: newChildPath,
          children: (node.children || []).map(renameRecursively)
        };
      }

      return {
        ...node,
        children: (node.children || []).map(renameRecursively)
      };
    };

    // 🌳 árbol principal
    setDataInicial(prev => prev.map(renameRecursively));

    // 🌳 menú
    setMenuTree(prev => prev.map(renameRecursively));

    // 🔄 refrescar vista actual
    if (String(selectedKey) === String(updatedFolder.parentKey)) {
      setFilteredFolders(prev =>
        prev.map(folder =>
          String(folder.id) === String(updatedFolder.id)
            ? { ...folder, name: updatedFolder.name, path: cleanNewPath }
            : folder
        )
      );
    }

    // 🍞 breadcrumb
    setBreadcrumbPath(prev =>
      prev.map(item =>
        String(item.id) === String(updatedFolder.id)
          ? { ...item, name: updatedFolder.name }
          : item
      )
    );

    // 🎯 carpeta seleccionada
    if (String(selectedKey) === String(updatedFolder.id)) {
      setSelectedFolder(updatedFolder.name);
    }
  };





  // Función para mostrar el modal
  const showDeleteConfirmation = (folder) => {
    setFolderToDelete(folder);
    setDeleteModalVisible(true);
  };

  // Función para manejar la eliminación de carpetas
  const handleDeleteFolder = async () => {
    try {
      setLoading(true);

      const response = await deleteFolder({
        folderId: folderToDelete.id,
        username: userLogin
      });

      message.success(response.message);

      const idsToRemove = new Set([String(folderToDelete.id)]);

      setDataInicial(prev => removeNodesByIds(prev, idsToRemove));
      setMenuTree(prev => removeNodesByIds(prev, idsToRemove));

      // limpiar vista si estábamos dentro
      if (String(selectedKey) === String(folderToDelete.id)) {
        setFilteredFolders([]);
        setFilteredDataFiles([]);
        setBreadcrumbPath([]);
        setSelectedKey(null);
      } else {
        setFilteredFolders(prev =>
          prev.filter(folder => String(folder.id) !== String(folderToDelete.id))
        );
      }

      setDeleteModalVisible(false);

    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 404:
            message.error(data.message || "Carpeta no encontrada.");
            break;
          case 500:
            message.error(data.message || "Error interno del servidor.");
            break;
          default:
            message.error(data.message || "No se pudo eliminar la carpeta.");
        }
      } else {
        message.error("No se pudo eliminar la carpeta.");
      }
    } finally {
      setLoading(false);
    }
  };


  // Función para actualizar el estado después de eliminar una carpeta
  const removeNodesByIds = (nodes, idsToRemove) => {
    if (!Array.isArray(nodes)) return nodes;

    return nodes
      .filter(node => !idsToRemove.has(String(node.id)))
      .map(node => ({
        ...node,
        children: node.children
          ? removeNodesByIds(node.children, idsToRemove)
          : []
      }));
  };


  // Función para mostrar el modal de renombrar
  const showRenameModal = (folder) => {
    setFolderToRename(folder);
    setRenameModalVisible(true);
  };

  // Subcomponente o función que muestra la “Ruta actual”
  const RutaActual = ({ currentPath = [] }) => {
    return (
      <div
        style={{
          backgroundColor: "#fafafa",
          padding: 16,
          borderRadius: 8,
          marginBottom: 16,
          border: "1px solid #d9d9d9",
          maxHeight: 160,          // 🔑 evita modales gigantes
          overflowY: "auto"
        }}
      >
        <Divider orientation="left" orientationMargin={0}>
          <Space>
            <FolderOpenOutlined style={{ color: "#1677ff", fontSize: 16 }} />
            <Text strong>Ruta actual</Text>
          </Space>
        </Divider>

        {/* 🔹 CONTENEDOR FLEXIBLE */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",      // 🔑 wrap automático
            alignItems: "center",
            rowGap: 6,
            columnGap: 4
          }}
        >
          {currentPath.map((folderObj, index) => (
            <React.Fragment key={folderObj.id}>
              {index > 0 && (
                <RightOutlined
                  style={{
                    fontSize: 11,
                    color: "#999",
                    margin: "0 4px"
                  }}
                />
              )}

              <Text
                strong
                style={{
                  fontSize: 13,
                  maxWidth: 220,            // 🔑 evita bloques enormes
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  lineHeight: 1.4
                }}
              >
                {formatName(folderObj.name)}
              </Text>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };


  // Mostrar modal
  const showDeleteFileConfirmation = (file) => {
    setFileToDelete(file);
    setDeleteFileModalVisible(true);
  };

  // Agregar archivo
  const handleFileUploaded = (newFile) => {
    const parentId = Number(newFile.parentKey);

    // 1️⃣ Actualizar vista actual
    if (Number(selectedKey) === parentId) {
      setFilteredDataFiles(prev => [...prev, newFile]);
      setRootFileCount(prev => prev + 1);
    }

    // 2️⃣ Insertar en árbol
    const insertFileIntoTree = (node) => {
      if (Number(node.id) === parentId) {
        return {
          ...node,
          children: [...(node.children || []), newFile],
        };
      }

      return {
        ...node,
        children: (node.children || []).map(insertFileIntoTree),
      };
    };

    // 3️⃣ Actualizar árbol
    setDataInicial(prev => prev.map(insertFileIntoTree));

    // 4️⃣ Actualizar menú
    setMenuTree(prev => prev.map(insertFileIntoTree));
  };



  // Eliminar archivo
  const handleDeleteFile = async () => {
    try {
      setLoading(true);
      const response = await deleteFile({ fileId: fileToDelete.id, username: userLogin });
      message.success(response.message);
      handleFileDeleted(fileToDelete.id);
      setDeleteFileModalVisible(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 404:
            message.error(data.message || "Archivo no encontrado.");
            break;
          case 500:
            message.error(data.message || "Error interno del servidor.");
            break;
          default:
            message.error(data.message || "No se pudo eliminar el archivo.");
        }
      } else {
        message.error("No se pudo eliminar el archivo.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Función para actualizar el estado después de eliminar un archivo
  const handleFileDeleted = (deletedFileId) => {
    const removeFileFromNode = (node) => {
      if (!node.children) return node;

      return {
        ...node,
        children: node.children
          .filter(child => String(child.id) !== String(deletedFileId))
          .map(removeFileFromNode)
      };
    };
    // 🔑 recorrer TODO el árbol (array raíz)
    setDataInicial(prev =>
      Array.isArray(prev)
        ? prev.map(removeFileFromNode)
        : prev
    );
    // 🔑 refrescar menú también
    setMenuTree(prev =>
      Array.isArray(prev)
        ? prev.map(removeFileFromNode)
        : prev
    );
    // 🔄 refrescar vista actual
    setFilteredDataFiles(prev =>
      prev.filter(file => String(file.id) !== String(deletedFileId))
    );
  };


  // Función para mostrar el modal de eliminación múltiple
  const showDeleteMultipleFilesConfirmation = () => {
    Modal.confirm({
      title: "Eliminar archivos",
      content: `¿Estás segur@ de eliminar los ${selectedItems.length} archivos seleccionados?`,
      okText: "Eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: () => handleDeleteMultipleFiles(selectedItems),
    });
  };

  // Función para eliminar múltiples archivos
  const handleDeleteMultipleFiles = async (fileIds) => {
    try {
      setLoading(true);

      const results = await Promise.allSettled(
        fileIds.map(id =>
          deleteFile({ fileId: id, username: userLogin })
        )
      );

      const successIds = [];
      const failedIds = [];

      results.forEach((res, index) => {
        if (res.status === "fulfilled") {
          successIds.push(String(fileIds[index]));
        } else {
          failedIds.push(String(fileIds[index]));
        }
      });

      if (successIds.length > 0) {
        const idsSet = new Set(successIds);

        setDataInicial(prev => removeNodesByIds(prev, idsSet));
        setMenuTree(prev => removeNodesByIds(prev, idsSet));

        setFilteredDataFiles(prev =>
          prev.filter(file => !idsSet.has(String(file.id)))
        );
      }

      if (failedIds.length > 0) {
        message.warning(
          `⚠️ ${failedIds.length} archivo(s) no pudieron eliminarse.`
        );
      }

      if (successIds.length > 0) {
        message.success(`${successIds.length} archivo(s) eliminados correctamente.`);
      }

      setSelectedItems([]);

    } catch (err) {
      message.error("Error al eliminar archivos.");
    } finally {
      setLoading(false);
    }
  };


  // Función recursiva para encontrar un archivo en el árbol
  const findFileInTree = (node, fileId) => {
    if (node.type === "file" && node.id === fileId) {
      return node;
    }

    if (node.children) {
      for (const child of node.children) {
        const result = findFileInTree(child, fileId);
        if (result) return result;
      }
    }

    return null;
  };

  // Función para descargar múltiples archivos como ZIP
  const handleDownloadZip = async () => {
    setDlProgress({ label: `Generando ZIP de ${selectedItems.length} archivos…`, percent: -1, loaded: 0, total: 0 });
    try {
      const response = await downloadZip(selectedItems, (percent, loaded, total) => {
        setDlProgress({
          label: `Descargando ZIP de ${selectedItems.length} archivos…`,
          percent,
          loaded,
          total,
        });
      });
      triggerBlobDownload(
        new Blob([response.data], { type: 'application/zip' }),
        'archivos.zip'
      );
      message.success("Descarga completa");
    } catch (err) {
      message.error("Error al descargar archivos");
      console.error(err);
    } finally {
      setDlProgress(null);
    }
  };

  // Función para alternar la visibilidad de la lista de carpetas
  const toggleLista = () => {
    setMostrarLista(prev => !prev);
  };

  // Función para ordenar carpetas (números primero, luego alfabético)
  const sortedFolders = [...filteredFolders].sort((a, b) => {
    const getPrefixNumber = (name) => {
      const match = name.match(/^(\d+)/);
      return match ? parseInt(match[1], 10) : null;
    };
    const aNum = getPrefixNumber(a.name);
    const bNum = getPrefixNumber(b.name);
    if (aNum !== null && bNum !== null) {
      return aNum - bNum;
    } else if (aNum !== null) {
      return -1;
    } else if (bNum !== null) {
      return 1;
    } else {
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    }
  });

  // Función para buscar archivos por nombre (búsqueda recursiva)
  function buscarArchivosPorNombre(data, searchTerm) {
    const archivosEncontrados = [];
    function recorrer(nodos) {
      for (const nodo of nodos) {
        if (nodo.type === 'file' && nodo.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          archivosEncontrados.push(nodo);
        }
        if (nodo.children && nodo.children.length > 0) {
          recorrer(nodo.children);
        }
      }
    }
    recorrer(data);
    return archivosEncontrados;
  }

  // Función para aplicar filtros y ordenamientos
  const applyFilters = () => {
    let filteredData = [...filteredDataFiles]; // Copia de los datos originales
    if (filterFile && searchTerm) {
      filteredData = buscarArchivosPorNombre(filterFile, searchTerm);
    }
    // Filtrar por tipo de archivo (mejorado para manejar extensiones)
    if (filterType !== 'all') {
      filteredData = filteredData.filter(item => {
        // Extraer la extensión del nombre del archivo
        const fileExt = item.name.split('.').pop().toLowerCase();
        // Mapeo de tipos a extensiones
        const typeMap = {
          'pdf': ['pdf'],
          'docx': ['docx', 'doc'],
          'xlsx': ['xlsx', 'xls'],
          'jpg': ['jpg', 'jpeg'],
          'png': ['png'],
          'url': ['url', 'http', 'https'] // Para enlaces
        };
        return typeMap[filterType]?.includes(fileExt) || false;
      });
    }

    // Ordenar los datos (mejorado para números primero)
    filteredData.sort((a, b) => {
      if (sortBy === 'name') {
        // Función para extraer partes numéricas y alfabéticas
        const getSortableValue = (str) => {
          // Extraer números del principio del string
          const numMatch = str.match(/^\d+/);
          const numPart = numMatch ? parseInt(numMatch[0], 10) : null;
          const alphaPart = numMatch ? str.slice(numMatch[0].length) : str;

          return {
            num: numPart !== null ? numPart : Infinity, // Poner números primero
            alpha: alphaPart.toLowerCase()
          };
        };

        const aVal = getSortableValue(a.name);
        const bVal = getSortableValue(b.name);

        // Primero comparar partes numéricas
        if (aVal.num !== bVal.num) {
          return sortOrder === 'asc'
            ? aVal.num - bVal.num
            : bVal.num - aVal.num;
        }

        // Si las partes numéricas son iguales, comparar alfabéticamente
        return sortOrder === 'asc'
          ? aVal.alpha.localeCompare(bVal.alpha)
          : bVal.alpha.localeCompare(aVal.alpha);
      } else if (sortBy === 'date') {
        const parseCustomDate = (dateStr) => {
          if (!dateStr) return new Date(0);
          const parts = dateStr.split('-');
          if (parts.length === 3) {
            return new Date(parts[2], parts[1] - 1, parts[0]);
          }
          return new Date(dateStr);
        };
        const dateA = parseCustomDate(a.createdAt);
        const dateB = parseCustomDate(b.createdAt);
        return sortOrder === 'asc'
          ? dateA - dateB
          : dateB - dateA;
      } else if (sortBy === 'size') {
        return sortOrder === 'asc'
          ? a.size - b.size
          : b.size - a.size;
      }
      return 0;
    });

    return filteredData;
  };

  // Aplicar filtros y ordenamientos
  const filteredData = applyFilters();

  // Archivos que se pueden seleccionar (excluye planes pedagógicos)
  const selectableFiles = filteredData.filter((file) => !file.planesPP);

  // Función para seleccionar todos los archivos visibles
  const handleSelectAllFiles = () => {
    setSelectedItems(selectableFiles.map((file) => file.id));
  };

  // Manejar búsqueda
  const onSearch = (value) => {
    setSearchTerm(value);
  };

  // Función para mostrar el plan pedagógico
  const handleShowPlan = (file) => {
    setSelectedFilePalnPedagogico(file); // Asumiendo que planesPP contiene tu JSON
    setModalVisiblePalnPedagogico(true);
  };

  // Determinar color del header según el modo
  const headerColor = REPOSITORY_MODES[mode]?.headerColor ?? "#1677ff";

  const buildMenuItems = (items = []) => {
    return items
      .filter(item => item.type === "folder")
      .map(item => ({
        key: String(item.id), // 🔴 siempre string
        icon: <FolderOutlined />,
        label: formatName(item.name),
        onTitleClick: () => handleClick(item),
        children: buildMenuItems(item.children || [])
      }));
  };

  return (
    <Drawer
      className="custom-drawer-repositorio"
      placement="right"
      size="large"
      onClose={onClose}
      open={open}
      closable={false}
      width={"100%"}
      destroyOnHidden={true}
      title={
        <Row
          align="middle"
          justify="space-between"
          style={{ background: headerColor, width: "100%", flexWrap: "nowrap", height: "60px" }}
        >
          <Col>
            <Space align="center">
              <Button
                size="small"
                type="text"
                icon={menuVisible ? <LeftOutlined /> : <RightOutlined />}
                style={{ color: "#FFF", fontSize: "20px" }}
                onClick={() => setMenuVisible(!menuVisible)}
              />
              <h3 style={{ margin: 0, color: "#FFF", fontWeight: 600, letterSpacing: "0.3px", }}>
                {REPOSITORY_MODES[mode]?.title ?? "Repositorio documental"}
              </h3>
            </Space>
          </Col>
          <Col flex="auto">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "12px",
                flexWrap: "wrap",
                verticalAlign: "middle",
              }}
            >

              <Search
                placeholder="Buscar archivo..."
                onSearch={onSearch}
                onChange={(e) => onSearch(e.target.value)}
                style={{ maxWidth: 300 }}
                enterButton={
                  <Button
                    type="text"
                    icon={<SearchOutlined style={{ color: "#FFF" }} />}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.15)",
                      border: "none",
                    }}
                  />
                }
                allowClear // Permite limpiar la búsqueda fácilmente
              />


              {(selectedKey === 1 || selectedKey === null) && (
                <Button onClick={toggleLista}>
                  <OrderedListOutlined />
                  {mostrarLista ? 'Ocultar lista' : 'Mostrar lista'}
                </Button>

              )}

              < Dropdown menu={filterMenu} trigger={["click"]}>
                <Button icon={<FilterOutlined />}>Filtrar</Button>
              </Dropdown>
              <Dropdown menu={{ items }} trigger={["click"]}>
                <Button icon={<AppstoreOutlined />}>Vista</Button>
              </Dropdown>


              {permissionInsert && (

                <CrearCarpeta
                  parentId={selectedKey}
                  diseno={1}
                  currentPath={currentPathString}
                  username={userLogin}
                  onFolderCreated={handleNewFolder}
                  onFolderUploaded={handleUploadFolder}
                  onFileUploaded={handleFileUploaded}
                  pathActual={selectedPath}
                  onDownloadFolder={permissionExport ? handleDownloadCurrentFolder : undefined}
                />

              )}
              <Button type="primary" icon={<CloseOutlined />} onClick={onClose} style={{ background: "#FFF", color: "#000" }}></Button>
            </div>
          </Col>
        </Row >
      }

    >
      {/* Contenedor principal del Drawer */}
      < div className="container-repositorio" >
        {/* Menú lateral con pestañas y estadísticas */}
        {menuVisible && (

          <div className="menu-repositorio">
            <div className="botones-tab-repositorio">
              {/* Pestañas de navegación */}
              <div className="border-bottom">
                <Tabs
                  defaultActiveKey="all"
                  onChange={setActiveTab}
                  centered
                  items={[
                    { key: "all", label: "Todos" },
                    { key: "favorites", label: "Favoritos" },
                  ]}
                />

              </div>

              {/* Estadísticas del repositorio */}
              {activeTab === "all" && (

                <div className="p-3 border-bottom bg-light">
                  <div className="small text-muted">
                    <Space direction="vertical" style={{ width: "100%" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <Text>
                          <FileOutlined style={{ marginRight: 8, color: "#1677ff" }} />
                          Total archivos:
                        </Text>
                        <Text strong>{stats.totalFiles.toLocaleString()}</Text>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <Text>
                          <FolderOpenOutlined style={{ marginRight: 8, color: "#52c41a" }} />
                          Total carpetas:
                        </Text>
                        <Text strong>{stats.totalFolders.toLocaleString()}</Text>
                      </div>
                    </Space>
                  </div>
                </div>
              )}

              {/* Contenido de las pestañas */}
              <div style={{ height: "calc(100vh - 200px)", overflowY: "auto" }}>
                {isLoading ? (
                  <div className="d-flex flex-column align-items-center justify-content-center h-100">
                    <Spin size="large" />
                    <Text type="secondary">Cargando carpetas...</Text>

                  </div>
                ) : (
                  <div>
                    {activeTab === "all" && (
                      <div style={{ height: "calc(100vh - 200px)", overflowY: "auto" }}>
                        {isLoading ? (
                          <div className="d-flex flex-column align-items-center justify-content-center h-100">
                            <Spin size="large" />
                            <Text type="secondary">Cargando carpetas...</Text>
                          </div>
                        ) : (
                          <Menu
                            mode="inline"
                            selectedKeys={[String(selectedKey)]}
                            openKeys={openKeys}
                            onOpenChange={setOpenKeys}
                            items={buildMenuItems(menuTree || [])}
                          />
                        )}
                      </div>
                    )}
                    {activeTab === "recent" && (
                      <div className="p-2">
                        <Title level={5} type="secondary">
                          Accedidos recientemente
                        </Title>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center p-2 hover-bg-light rounded"
                          >
                            <ClockCircleOutlined className="me-2 text-muted" />
                            <Text className="small">
                              Documento accedido recientemente {i + 1}
                            </Text>
                          </div>
                        ))}
                        <Title level={5} type="secondary" className="mt-4">
                          Modificados recientemente
                        </Title>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center p-2 hover-bg-light rounded"
                          >
                            <HistoryOutlined className="me-2 text-muted" />
                            <Text className="small">
                              Archivo modificado recientemente {i + 1}
                            </Text>
                          </div>
                        ))}
                      </div>
                    )}
                    {activeTab === "favorites" && (
                      <div className="p-2">
                        <Title level={5} type="secondary">
                          Elementos favoritos
                        </Title>
                        {favorites.length > 0 ? (
                          favorites.map((id) => {
                            const file = findFileInTree(dataInicial, id);
                            if (!file) return null;

                            return (
                              <div
                                key={id}
                                className="d-flex align-items-center p-2 hover-bg-light rounded"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleOpen(file)} // ✅ usamos tu función directamente
                              >
                                <StarFilled className="me-2 text-warning" />
                                <Tooltip title="Abrir archivo">
                                  <Text className="small" style={{ color: "#1677ff" }}>
                                    {file.name}
                                  </Text>
                                </Tooltip>
                              </div>
                            );
                          })
                        ) : (
                          <div
                            className="text-center d-flex flex-column align-items-center justify-content-center"
                            style={{ minHeight: "200px" }}
                          >
                            <HeartOutlined
                              style={{
                                fontSize: "50px",
                                opacity: 0.2,
                                color: "#dddddd",
                              }}
                              className="mb-2"
                            />
                            <Text className="small" style={{ color: "#8C8C8C" }}>
                              No hay elementos favoritos
                            </Text>
                            <Text
                              className="small mt-1"
                              style={{ color: "#8C8C8C" }}
                            >
                              Marca archivos como favoritos para acceder
                              rápidamente
                            </Text>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )
        }
        {/* Contenido principal del repositorio */}
        <div className="content-repositorio">
          <div>
            {/* Título de la carpeta actual */}
            <div className="mb-3 mt-2">
              <Typography.Title
                level={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 0,
                }}
              >
                <FolderOpenOutlined
                  style={{ fontSize: "20px", marginRight: "5px", color: "#0d6efd" }}
                />
                <strong style={{ fontSize: "15px", }}>{formatName(selectedFolder)}</strong>
              </Typography.Title>
              <div style={{ fontSize: "12px", color: "#666" }}>
                {rootFileCount} documento{rootFileCount !== 1 ? "s" : ""} •{" "}
                {totalFolderCount} subcarpeta{totalFolderCount !== 1 ? "s" : ""}
              </div>
              {/* Breadcrumb para navegación */}
              <Col style={{ flex: 1, minWidth: 0, maxWidth: "1200px" }}>
                <div className="d-flex align-items-center overflow-auto pb-2 pb-md-0">
                  <strong>Ubicación: </strong>
                  {breadcrumbPath.map((folderObj, index) => (
                    <div key={folderObj.id} className="d-flex align-items-center">
                      {index > 0 && (
                        <RightOutlined
                          className="mx-0 text-muted"
                          style={{ fontSize: "12px" }}
                        />
                      )}

                      <Button
                        type="link"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={(e) =>
                          navigateToFolder(breadcrumbPath.slice(0, index + 1), e)
                        }
                      >

                        <strong>{formatName(folderObj.name)}</strong>
                      </Button>
                    </div>
                  ))}
                </div>
              </Col>
              {mode === "full" &&
                (selectedKey === 1 || selectedKey === null) &&
                mostrarLista && (
                  <Col style={{ flex: 1, minWidth: 0 }}>
                    <div className="d-flex justify-content-center w-100 overflow-auto pb-2 pb-md-0">
                      <ListaRepositorio />
                    </div>
                  </Col>
                )}
            </div>
            <div style={{ fontSize: "14px", color: "#666" }}>
              {sortedFolders.length === 0 && filteredDataFiles.length === 0 ? (
                <>
                  <Divider style={{ margin: "20px 0" }} />
                  <div className="text-center py-2">
                    <FolderOpenOutlined style={{ fontSize: "3rem" }} className="text-muted mb-3" />
                    <h5>No hay carpetas</h5>
                    <p className="text-muted mb-4">
                      {searchQuery
                        ? "No se encontraron archivos que coincidan con tu búsqueda."
                        : "Esta carpeta está vacía."}
                    </p>
                    {permissionInsert && (
                      <CrearCarpeta
                        parentId={selectedKey}
                        diseno={2}
                        currentPath={currentPathString}
                        username={userLogin}
                        onFolderCreated={handleNewFolder}
                        onFolderUploaded={handleUploadFolder}
                        onFileUploaded={handleFileUploaded}
                        pathActual={selectedPath}
                      />
                    )}
                    {searchQuery && (
                      <Button type="primary" onClick={() => setSearchQuery("")}>
                        Limpiar búsqueda
                      </Button>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {sortedFolders.length > 0 && (
                    <>
                      <Divider style={{ borderColor: '#1a1a1a', borderWidth: 2 }} orientation="left">
                        <strong>Carpetas</strong>
                      </Divider>
                      {/* Vista de LISTA para carpetas */}
                      {viewMode === "list" && (
                        <div className="d-flex flex-column gap-2">
                          {sortedFolders.map((folder) => {
                            const fileCount = folder.children?.length ?? 0;
                            return (
                              <Card
                                key={folder.id}
                                hoverable
                                className="mb-0"
                                style={{ padding: "12px" }}
                                onClick={() => handleClick(folder)}
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center flex-grow-1 min-width-0">
                                    <FolderOutlined className="me-3 fs-5 text-primary" />
                                    <div className="min-width-0">
                                      <Typography.Text
                                        strong
                                        className="d-block"
                                        style={{ wordBreak: "break-word", whiteSpace: "normal", fontSize: "13px" }}
                                      >
                                        {formatName(folder.name)}
                                      </Typography.Text>

                                      <Typography.Text type="secondary" className="small">
                                        {fileCount} elemento{fileCount !== 1 ? "s" : ""}
                                      </Typography.Text>
                                    </div>
                                  </div>
                                  <Dropdown menu={{ items: folderMenu(folder) }} trigger={["click"]}>
                                    <Button
                                      type="primary"
                                      shape="circle"
                                      icon={<EllipsisOutlined />}
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        backgroundColor: "#1677ff",
                                        borderColor: "#1677ff"
                                      }}
                                    />
                                  </Dropdown>
                                </div>
                              </Card>
                            );
                          })}
                        </div>
                      )}

                      {/* Vista de CUADRÍCULA (grid) para carpetas */}
                      {viewMode === "grid" && (
                        <Row gutter={[16, 16]} className="g-3">

                          {sortedFolders.map((folder) => {
                            const fileCount = folder.children?.length ?? 0;
                            return (
                              <Col key={folder.id} xs={6} sm={6} md={6} lg={6}>
                                <Card
                                  hoverable
                                  className="text-center position-relative"
                                  style={{ padding: "15px" }}

                                  onClick={() => handleClick(folder)}
                                >
                                  <FolderOutlined
                                    style={{ fontSize: "2.5rem" }}
                                    className="text-primary mb-2"
                                  />
                                  <Typography.Text strong className="d-block text-truncate">
                                    {formatName(folder.name)}
                                  </Typography.Text>
                                  <Typography.Text type="secondary" className="small">
                                    {fileCount} elemento{fileCount !== 1 ? "s" : ""}
                                  </Typography.Text>

                                  <Dropdown menu={{ items: folderMenu(folder) }} trigger={["click"]}>
                                    <Button
                                      type="text"
                                      shape="circle"
                                      icon={<EllipsisOutlined />}
                                      className="position-absolute top-0 end-0 m-1"
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </Dropdown>

                                </Card>
                              </Col>
                            );
                          })}
                        </Row>
                      )}

                      {/* Vista COMPACTA para carpetas */}
                      {viewMode === "compact" && (
                        <div className="border rounded overflow-auto">
                          <table className="table table-hover mb-0 table-responsive-name">
                            <thead className="bg-light">
                              <tr>
                                <th>Nombre</th>
                                <th style={{ textAlign: "center" }}>Recursos</th>
                                <th style={{ textAlign: "center", width: "80px" }}>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              {sortedFolders.map((folder) => {
                                const fileCount = folder.children?.length ?? 0;
                                return (
                                  <tr
                                    key={folder.id}

                                    onClick={() => handleClick(folder)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <td>
                                      <FolderOutlined className="me-2 fs-5 text-primary" />

                                      {formatName(folder.name)}
                                    </td>
                                    <td style={{ textAlign: "center" }}>{fileCount}</td>
                                    <td style={{ textAlign: "center" }}>
                                      <Dropdown menu={{ items: folderMenu(folder) }} trigger={["click"]}>
                                        <Button
                                          type="primary"
                                          shape="circle"
                                          icon={<EllipsisOutlined />}
                                          onClick={(e) => e.stopPropagation()}
                                          style={{
                                            backgroundColor: "#1677ff",  // tu color preferido
                                            borderColor: "#1677ff"       // mismo color para el borde
                                          }}
                                        />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}

                </>
              )}
            </div>
            <Divider style={{ margin: "15px 0" }} />
            {filteredData.length > 0 ? (
              <>
                <Divider style={{ borderColor: '#1a1a1a', borderWidth: 2 }} orientation="left">
                  <strong>Archivos</strong>
                </Divider>
                <Row className="mb-3" align="middle">
                  {/* Columna 1: Título, alineada a la izquierda */}
                  <Col xs={24} md={6} style={{ textAlign: "left" }}>
                  </Col>
                  {/* Columna 2: centrada (por ej. botones de items seleccionados) */}
                  <Col xs={24} md={12} style={{ textAlign: "center" }}>
                    {(selectedItems.length > 0 || selectableFiles.length > 0) && (
                      <div
                        style={{
                          backgroundColor: "#dee2e64d",
                          border: "0px solid #ccc",
                          padding: "8px",
                          borderRadius: "10px",

                        }}
                      >
                        {selectedItems.length > 0 && (
                          <Tooltip title="Elementos seleccionados">
                            <Button color="primary" style={{ background: "#1677ff", marginRight: 8, color: "#fff" }}>
                              {selectedItems.length}
                            </Button>
                          </Tooltip>
                        )}

                        {selectableFiles.length > 0 && selectedItems.length < selectableFiles.length && (
                          <Button onClick={handleSelectAllFiles} style={{ marginRight: 8 }}>
                            Seleccionar todo
                          </Button>
                        )}

                        {selectedItems.length > 0 && (
                          <>
                            <Button onClick={() => setSelectedItems([])} style={{ marginRight: 8 }}>
                              Deseleccionar todo
                            </Button>
                            {permissionExport && (
                              <Button
                                onClick={handleDownloadZip}
                                style={{ marginRight: 8 }}
                                icon={<DownloadOutlined />}
                              >
                                Descargar ZIP
                              </Button>
                            )}

                            {permissionDelete && (
                              <Button
                                danger
                                onClick={showDeleteMultipleFilesConfirmation}
                                icon={<DeleteOutlined />}
                              >
                                Eliminar
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </Col>
                  {/* Columna 3: alineada a la derecha (iconos de “vista” list/grid/compact) */}
                  <Col xs={24} md={6} style={{ textAlign: "right" }}>
                    <div style={{ display: "inline-flex", gap: "8px" }}>
                      <Tooltip title="Vista de lista">
                        <Button
                          type="text"
                          shape="default"
                          icon={
                            <UnorderedListOutlined style={{ fontSize: 20, fontWeight: "bold" }} />
                          }
                          onClick={() => setViewMode("list")}
                          style={{
                            backgroundColor: viewMode === "list" ? "#1677ff" : "transparent",
                            color: viewMode === "list" ? "#fff" : "inherit",
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Vista de cuadrícula">
                        <Button
                          type="text"
                          shape="default"
                          icon={
                            <HolderOutlined style={{ fontSize: 20, fontWeight: "bold" }} />
                          }
                          onClick={() => setViewMode("grid")}
                          style={{
                            backgroundColor: viewMode === "grid" ? "#1677ff" : "transparent",
                            color: viewMode === "grid" ? "#fff" : "inherit",
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Vista compacta">
                        <Button
                          type="text"
                          shape="default"
                          icon={
                            <FileTextOutlined style={{ fontSize: 20, fontWeight: "bold" }} />
                          }
                          onClick={() => setViewMode("compact")}
                          style={{
                            backgroundColor: viewMode === "compact" ? "#1677ff" : "transparent",
                            color: viewMode === "compact" ? "#fff" : "inherit",
                          }}
                        />
                      </Tooltip>
                    </div>
                  </Col>
                </Row>
                {viewMode === "list" && (
                  <div className="d-flex flex-column gap-2">
                    {filteredData.map((file) => (
                      <Card
                        key={file.id}
                        hoverable
                        className="mb-0"
                        style={{ padding: "12px" }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center flex-grow-1 min-width-0">
                            {!file.planesPP && (
                              <Checkbox
                                className="me-2"
                                checked={selectedItems.includes(file.id)}
                                onChange={() => toggleSelectItem(file.id)}
                                onClick={(e) => e.stopPropagation()}
                              />)}
                            {file.type === "file" ? (

                              <>
                                {getFileIconByExtension(file.extension)}
                              </>
                            ) : (
                              <GlobalOutlined className="me-3 fs-5 text-success" />
                            )}
                            <div className="min-width-0">
                              <Typography.Text strong className="d-block text-truncate">
                                <span
                                  onClick={() => handleOpen(file)}
                                  style={{
                                    cursor: 'pointer',
                                    color: '#1677ff',
                                    transition: 'color 0.2s',
                                  }}
                                  onMouseEnter={(e) => (e.target.style.color = '#0958d9')}
                                  onMouseLeave={(e) => (e.target.style.color = '#1677ff')}
                                >
                                  {file.name}
                                </span>
                              </Typography.Text>
                              <Typography.Text type="secondary" className="small">
                                {file.type === "file" ? file.size : "URL externa"} • {file.createdAt} • {file.user}
                              </Typography.Text>
                            </div>
                          </div>
                          <div className="d-flex align-items-center ms-2">
                            {file.planesPP && (
                              <Tooltip title="Plan Pedagógico">
                                <Button
                                  type="text"
                                  shape="circle"
                                  icon={<SettingOutlined />}
                                  onClick={() => handleShowPlan(file)}
                                />
                              </Tooltip>
                            )}
                          </div>
                          {!file.planesPP && (
                            <div className="d-flex align-items-center ms-2">
                              <Button
                                type="text"
                                shape="circle"
                                icon={
                                  favorites.includes(file.id) ? (
                                    <StarFilled className="text-warning" />
                                  ) : (
                                    <StarOutlined />
                                  )
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleFavorite(file.id);
                                }}
                              />
                              {/* Mostrar el Dropdown solo cuando el mouse está sobre la tarjeta */}
                              <Dropdown menu={{ items: fileMenu(file) }} trigger={["click"]}>
                                <Button type="text" shape="circle" icon={<MoreOutlined />} />
                              </Dropdown>
                            </div>)}
                        </div>
                      </Card>
                    ))}
                  </div>
                )}
                {/* Vista de cuadrícula */}
                {viewMode === "grid" && (
                  <Row gutter={[16, 16]} className="g-3"> {/* Agregamos espacio horizontal y vertical */}
                    {filteredDataFiles.map((file) => (
                      <Col key={file.id} xs={12} sm={12} md={12} lg={5} style={{ marginBottom: "16px" }}>
                        <Card
                          hoverable
                          className="text-center position-relative"
                          style={{ padding: "15px" }}
                          onClick={() => handleOpen(file)}
                        >
                          {/* Botón de favorito en la esquina superior derecha */}
                          {file.planesPP && (
                            <Tooltip title="Plan Pedagógico">
                              <Button
                                type="text"
                                shape="circle"
                                icon={<SettingOutlined />}
                                className="position-absolute top-0 end-0 m-1"
                                onClick={() => handleShowPlan(file)}
                              />
                            </Tooltip>
                          )}
                          {!file.planesPP && (
                            <Checkbox
                              className="position-absolute top-0 start-0 m-1"
                              checked={selectedItems.includes(file.id)}
                              onChange={() => toggleSelectItem(file.id)}
                              onClick={(e) => e.stopPropagation()}
                            />,
                            <Button
                              type="text"
                              shape="circle"
                              icon={
                                favorites.includes(file.id) ? (
                                  <StarFilled className="text-warning" />
                                ) : (
                                  <StarOutlined />
                                )
                              }
                              className="position-absolute top-0 end-0 m-1"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleFavorite(file.id);
                              }}
                            />)}
                          {/* Contenido central */}
                          <div className="py-2">
                            {file.type === "file" ? (
                              <>
                                {getFileIconByExtension(file.extension)}
                              </>
                            ) : (
                              <GlobalOutlined style={{ fontSize: "2.5rem" }} className="text-success mb-2" />
                            )}
                            {/* Tooltip para mostrar el nombre completo si es muy largo */}
                            <Tooltip title={file.name}>
                              <Typography.Text strong className="d-block text-truncate">
                                {file.name}
                              </Typography.Text>
                            </Tooltip>
                            <Typography.Text type="secondary" className="small">
                              {file.type === "file" ? file.size : "URL externa"} • {file.createdAt}
                            </Typography.Text>
                            <Typography.Text type="secondary" className="d-block text-truncate">
                              {file.user}
                            </Typography.Text>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
                {/* Vista compacta */}
                {viewMode === "compact" && (
                  <div className="border rounded overflow-auto">
                    <table className="table table-hover mb-0 table-responsive-name">
                      <thead className="bg-light">
                        <tr>
                          <th style={{ width: "40px" }}></th>
                          <th>Nombre</th>
                          <th style={{ width: "100px", textAlign: "center" }}>Tipo</th>
                          <th style={{ width: "100px", textAlign: "center" }}>Tamaño</th>
                          <th style={{ width: "150px" }}>Usuario</th>
                          <th style={{ width: "150px", textAlign: "center" }}>Fecha</th>
                          <th style={{ width: "80px" }}>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredDataFiles.map((file) => (
                          <tr key={file.id}>
                            <td> {!file.planesPP && (
                              <Checkbox
                                checked={selectedItems.includes(file.id)}
                                onChange={() => toggleSelectItem(file.id)}
                                onClick={(e) => e.stopPropagation()}
                              />)}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                {file.type === "file" ? (
                                  <>
                                    {getFileIconByExtension(file.extension)}
                                  </>
                                ) : (
                                  <GlobalOutlined className="me-2 icon-global" />
                                )}
                                <Tooltip title={file.name}>
                                  <span
                                    onClick={() => handleOpen(file)}
                                    style={{
                                      cursor: 'pointer',
                                      color: '#1677ff',
                                      transition: 'color 0.2s',
                                    }}
                                    onMouseEnter={(e) => (e.target.style.color = '#0958d9')}
                                    onMouseLeave={(e) => (e.target.style.color = '#1677ff')}
                                  >

                                    {file.name}</span>
                                </Tooltip>
                              </div>
                            </td>
                            <td style={{ textAlign: "center" }}>{file.name.split(".").pop()?.toUpperCase() || "URL"}</td>
                            <td style={{ textAlign: "center" }}>{file.type === "file" ? file.size : "-"}</td>
                            <td style={{ textAlign: "left" }}>{file.user}</td>
                            <td style={{ textAlign: "center" }}>{file.createdAt}</td>
                            <td>
                              {!file.planesPP && (
                                <div className="d-flex justify-content-center">
                                  <Tooltip title="Marcar como favorito">
                                    <Button
                                      type="text"
                                      size="small"
                                      icon={favorites.includes(file.id) ? <StarFilled className="icon-favorite" style={{ fontSize: 20 }} /> : <StarOutlined style={{ fontSize: 17 }} />}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleFavorite(file.id);
                                      }}
                                    />
                                  </Tooltip>
                                  {permissionExport && (
                                    <Tooltip title="Descargar archivo">
                                      <Button
                                        type="text"
                                        size="small"
                                        icon={<DownloadOutlined className="icon-download" style={{ fontSize: 17 }} />}
                                        onClick={() => handleDownload(file)}  // Asegúrate de agregar esta línea si falta
                                      />
                                    </Tooltip>
                                  )}
                                  {permissionDelete && (
                                    <Tooltip title="Eliminar archivo">
                                      <Button
                                        type="text"
                                        size="small"
                                        icon={<DeleteOutlined className="icon-delete" style={{ fontSize: 17 }} />}
                                        onClick={() => showDeleteFileConfirmation(file)}
                                      />
                                    </Tooltip>
                                  )}
                                </div>)}
                              {file.planesPP && (
                                <div className="d-flex justify-content-center">
                                  <Tooltip title="Plan Pedagógico">
                                    <Button
                                      type="text"
                                      size="small"
                                      icon={<SettingOutlined className="icon-download" style={{ fontSize: 17 }} />}
                                      onClick={() => handleShowPlan(file)}  // Asegúrate de agregar esta línea si falta
                                    />
                                  </Tooltip>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {/* Paginación */}
                {totalPages > 1 && (
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4">
                    <div className="text-muted small mb-3 mb-sm-0">
                      Mostrando {(currentPage - 1) * itemsPerPage + 1} -{" "}
                    </div>
                    <Pagination
                      current={currentPage}
                      total={filteredFiles.length}
                      pageSize={itemsPerPage}
                      onChange={(page) => setCurrentPage(page)}
                      showSizeChanger={false}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                {filteredFolders.length === 0 && (
                  <div className="text-center py-5">
                    <FileOutlined style={{ fontSize: "3rem" }} className="text-muted mb-3" />
                    <h5>No hay archivos</h5>
                    <p className="text-muted mb-4">
                      {searchQuery
                        ? "No se encontraron archivos que coincidan con tu búsqueda."
                        : "Esta carpeta está vacía, sin archivos."}
                    </p>
                    {permissionInsert && (
                      <CrearCarpeta
                        parentId={selectedKey}
                        diseno={3}
                        currentPath={currentPathString}
                        username={userLogin}
                        pathActual={selectedPath}
                        onFolderCreated={handleNewFolder}
                        onFolderUploaded={handleUploadFolder}
                        onFileUploaded={handleFileUploaded}
                      />
                    )}
                    {searchQuery && (
                      <Button type="primary" onClick={() => setSearchQuery("")}>
                        Limpiar búsqueda
                      </Button>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div >
      {renameModalVisible && folderToRename && (
        <RenombrarCarpeta
          visible={renameModalVisible}
          folder={folderToRename}
          onFolderRenamed={handleFolderRenamed}
          username={userLogin}
          onClose={() => setRenameModalVisible(false)}
        />
      )}
      {
        deleteModalVisible && permissionDelete && (
          <Modal
            destroyOnHidden={true}
            open={deleteModalVisible}
            title="Eliminar carpeta"
            onCancel={() => setDeleteModalVisible(false)}
            footer={null}
            width="90%"
            style={{ maxWidth: 600 }}
          >
            <Spin spinning={loading} tip="Eliminando carpeta...">
              <p>¿Estás segur@ de eliminar esta carpeta? <br />Se eliminará de forma recursiva.</p>
              <div style={{ textAlign: "right", marginTop: 16 }}>
                <Button onClick={() => setDeleteModalVisible(false)} style={{ marginRight: 8 }}>
                  Cancelar
                </Button>
                <Button type="primary" danger onClick={handleDeleteFolder}>
                  Eliminar
                </Button>
              </div>
              <Divider />
              <RutaActual currentPath={pathForDeletion} />
            </Spin>
          </Modal>)
      }
      {
        deleteFileModalVisible && permissionDelete && (
          <Modal
            open={deleteFileModalVisible}
            title="Eliminar archivo"
            onCancel={() => setDeleteFileModalVisible(false)}
            footer={null}
            destroyOnHidden={true}
            width={600}
            style={{ maxWidth: "90%" }}
          >
            <Spin spinning={loading} tip="Eliminando archivo...">
              <p>¿Estás segur@ de eliminar este archivo?</p>
              <div style={{ textAlign: "right", marginTop: 16 }}>
                <Button onClick={() => setDeleteFileModalVisible(false)} style={{ marginRight: 8 }}>
                  Cancelar
                </Button>
                <Button type="primary" danger onClick={handleDeleteFile}>
                  Eliminar
                </Button>
              </div>
            </Spin>
          </Modal>
        )
      }
      {selectedFilePalnPedagogico && modalVisiblePalnPedagogico && (
        <PedagogicalPlanModal
          open={modalVisiblePalnPedagogico} // ✅ aquí debe ser "open"
          onCancel={() => setModalVisiblePalnPedagogico(false)}
          data={selectedFilePalnPedagogico}
        />)}
      {loading && (
        <Spin size="large" style={{ position: "fixed", top: "50%", left: "50%" }} />
      )}

      {/* ── Widget de progreso de descarga ── */}
      {dlProgress && (
        <div style={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 9999,
          background: '#fff',
          border: '1px solid #d9d9d9',
          borderRadius: 8,
          padding: '14px 18px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.14)',
          minWidth: 300,
          maxWidth: 380,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <Typography.Text strong style={{ fontSize: 13, flex: 1, marginRight: 8 }} ellipsis>
              {dlProgress.label}
            </Typography.Text>
            {dlProgress.percent >= 0 && (
              <Typography.Text strong style={{ color: '#1677ff', fontSize: 13, whiteSpace: 'nowrap' }}>
                {dlProgress.percent}%
              </Typography.Text>
            )}
          </div>

          {dlProgress.percent >= 0 ? (
            <Progress
              percent={dlProgress.percent}
              status={dlProgress.percent === 100 ? 'success' : 'active'}
              strokeColor={{ from: '#1677ff', to: '#52c41a' }}
              size="small"
              showInfo={false}
            />
          ) : (
            <Progress percent={100} status="active" strokeColor="#1677ff" size="small" showInfo={false} />
          )}

          {dlProgress.loaded > 0 && (
            <Typography.Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 4 }}>
              {formatBytes(dlProgress.loaded)}
              {dlProgress.total > 0 ? ` / ${formatBytes(dlProgress.total)}` : ' recibidos'}
            </Typography.Text>
          )}
        </div>
      )}
    </Drawer >
  );
};

export default RepositorioDocumento;